import { Box, Text } from '@bonanza-social/moonlight';
import { PromotionReward } from '@bonanza-social/promos';
import { boxesArray } from './InviteFriendsRewards.constants';
import { useSelector } from '@bonanza-social/toolkit/state';
import React from 'react';
import RewardLine from './RewardLine';
import { useTranslation } from '@bonanza-social/i18n';
import { selectLandingWelcomeGenericPromo } from '@bonanza-social/auth';

type Props = {
  rewards: PromotionReward[];
  refereeRewards?: PromotionReward[];
  promoType?: string;
};

function InviteFriendsRewards({ rewards, refereeRewards, promoType }: Props) {
  const welcomePromo = useSelector(selectLandingWelcomeGenericPromo);
  const welcomeReward = welcomePromo?.[0]?.rewards?.[0];
  const { t } = useTranslation('inviteFriends');

  return (
    <Box flexDirection="column">
      {boxesArray.map((box) => {
        const isRefereeBox = box.type === 'referee';
        const currentRewards = isRefereeBox ? (refereeRewards ?? []) : rewards;

        if (isRefereeBox && currentRewards.length === 0) return null;

        return (
          <Box
            key={box.type}
            backgroundColor="secondaryBackgroundDefault"
            gap="space-100"
            padding="space-200"
            borderRadius="radius-200"
            marginVertical="space-100"
          >
            <Text
              variant="body-s-semi"
              color="darkSurfacePrimary"
              locNS="inviteFriends"
              locKey={box.locKey}
            />

            {currentRewards.map((reward, idx) => {
              const key = `${reward?.rewardTarget ?? 'reward'}-${idx}`;

              if (isRefereeBox && welcomeReward) {
                return (
                  <Box key={key}>
                    {promoType === 'Referral' && (
                      <RewardLine
                        reward={welcomeReward}
                        suffix={t('welcomeBonusSuffix')}
                      />
                    )}
                    <RewardLine
                      reward={reward}
                      suffix={t('referralBonusSuffix')}
                    />
                  </Box>
                );
              }

              return <RewardLine key={key} reward={reward} />;
            })}
          </Box>
        );
      })}
    </Box>
  );
}

export default InviteFriendsRewards;
